import React, { useEffect } from 'react';
import { Routes, Route, useSearchParams } from 'react-router-dom';
import { ConfigProvider, Layout, Typography, message } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import zhCN from 'antd/locale/zh_CN';
import { useTranslation } from 'react-i18next';
import { decryptUid } from './utils/encryption';
import Home from './pages/Home';
import './App.css';
import './i18n/config';

const { Title } = Typography;
const { Content, Footer } = Layout;

// 创建 QueryClient 实例
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  // 检查URL中是否包含推广ID
  useEffect(() => {
    const encryptedUid = searchParams.get('uid');
    if (encryptedUid) {
      const handleDecrypt = async () => {
        try {
          const decryptedId = decryptUid(encryptedUid);
          localStorage.setItem('referralId', decryptedId);
        } catch (error) {
          console.error('解密推广ID失败:', error);
        }
      };
      handleDecrypt();
    }
  }, [searchParams]);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={zhCN}>
        <Layout className="app">
          <Content className="content">
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
          </Content>
          <Footer className="footer">
            <div className="footer-content">
              <p>© 2025 DeFi. {t('common.allRightsReserved')}</p>
            </div>
          </Footer>
        </Layout>
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default App; 